export const defaultXlsxFileName = 'analysis.xlsx';
